import { ContinueShoppingData } from './types';

export const mockData: ContinueShoppingData = [
    {
        category_id: 68510924,
        category_name: 'Street Style Sneakers',
        has_more: true,
        configs: Array.from({ length: 9 }, (_, i) => ({
            sku: `NI123456-${i + 1}`,
            brand: 'Nike',
            media: {
                media_type: 'image',
                character_code: 'A',
                path: 'spp-media-p1/99b5b0876ae34790a559ece9be416b88/0a25ea58e9494c3ab2f8180b9c36af99.jpg',
                preview_path:
                    'spp-media-p1/99b5b0876ae34790a559ece9be416b88/0a25ea58e9494c3ab2f8180b9c36af99.jpg',
                alt_text: 'Nike Air Max sneakers',
            },
            campaign_identifier: 'CAMP2024_001',
            has_similar: true,
            url_path: {
                '1': '/men/sneakers/nike-air-max-123456',
                '2': '/herren/sneakers/nike-air-max-123456',
            },
            stock_status: 'AVAILABLE',
            plus_early_access: false,
            sustainable: true,
            name_category_tag: 'Nike Air Max 270 - Sneakers',
            price: 12000,
            similar_prices: false,
            special_price: 8999,
            has_test_media: false,
        })),
    },
    {
        category_id: 224638028,
        category_name: 'Jackets',
        has_more: true,
        configs: Array.from({ length: 15 }, (_, i) => ({
            sku: `NF567890-${i + 1}`,
            brand: 'The North Face',
            media: {
                media_type: 'image',
                character_code: 'A',
                path: 'spp-media-p1/949672d50eb8442193ac7c40c434e96c/f9eb1c69ade145f4b43f2dd598cf3cb7.jpg',
                preview_path:
                    'spp-media-p1/949672d50eb8442193ac7c40c434e96c/f9eb1c69ade145f4b43f2dd598cf3cb7.jpg',
                alt_text: 'The North Face puffer jacket',
            },
            campaign_identifier: 'CAMP2024_008',
            has_similar: true,
            url_path: {
                '1': '/men/jackets/north-face-puffer-567890',
            },
            stock_status: 'AVAILABLE',
            plus_early_access: false,
            sustainable: true,
            name_category_tag: 'The North Face 1996 Retro Nuptse - Jackets',
            price: 29900,
            similar_prices: false,
            special_price: 19999,
            has_test_media: false,
        })),
    },
    {
        category_id: 168765739,
        category_name: 'T-Shirts',
        has_more: true,
        configs: Array.from({ length: 8 }, (_, i) => ({
            sku: `PG678901-${i + 1}`,
            brand: 'Pegador',
            media: {
                media_type: 'image',
                character_code: 'A',
                path: 'spp-media-p1/70012f5b100546d1961faa38b9b37183/103e1e54edf0478f8ec63e5cfc20eaef.jpg',
                preview_path:
                    'spp-media-p1/70012f5b100546d1961faa38b9b37183/103e1e54edf0478f8ec63e5cfc20eaef.jpg',
                alt_text: 'Pegador oversized t-shirt',
            },
            campaign_identifier: 'CAMP2024_009',
            has_similar: false,
            url_path: {
                '1': '/men/t-shirts/pegador-oversized-678901',
            },
            stock_status: 'AVAILABLE',
            plus_early_access: false,
            sustainable: false,
            name_category_tag: 'Pegador Oversized Tee - T-Shirts',
            price: 4999,
            similar_prices: false,
            special_price: 2999,
            has_test_media: false,
        })),
    },
    {
        category_id: 228814038,
        category_name: 'Casual Dresses',
        has_more: true,
        configs: Array.from({ length: 9 }, (_, i) => ({
            sku: `ZA567890-${i + 1}`,
            brand: 'Zara',
            media: {
                media_type: 'image',
                character_code: 'A',
                path: 'spp-media-p1/99b5b0876ae34790a559ece9be416b88/0a25ea58e9494c3ab2f8180b9c36af99.jpg',
                preview_path:
                    'spp-media-p1/99b5b0876ae34790a559ece9be416b88/0a25ea58e9494c3ab2f8180b9c36af99.jpg',
                alt_text: 'Zara midi dress',
            },
            campaign_identifier: 'CAMP2024_028',
            has_similar: true,
            url_path: {
                '1': '/women/dresses/zara-midi-dress-567890',
            },
            stock_status: 'AVAILABLE',
            plus_early_access: false,
            sustainable: true,
            name_category_tag: 'Zara Midi Dress - Casual Dresses',
            price: 5999,
            similar_prices: false,
            special_price: 3999,
            has_test_media: false,
        })),
    },
];

export const mockContinueShoppingData: ContinueShoppingData = mockData;

// To check the behavior with one category, uncomment this line
// export const mockContinueShoppingData: ContinueShoppingData = [mockData[0]];
